import { render, staticRenderFns } from "./DraftOrdersModal.vue?vue&type=template&id=1683c906&"
import script from "./DraftOrdersModal.vue?vue&type=script&lang=js&"
export * from "./DraftOrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./DraftOrdersModal.vue?vue&type=style&index=0&id=1683c906&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports